import {
    AppDownloadButtons,
    type DownloadButtonProps,
} from '@/ui-components/molecules/AppDownloadButtons/AppDownloadButtons';
import { Text } from '@/ui-components/atoms/Text/Text';
import { SnapshotDivider } from '@/ui-components/organisms/Snapshot/SnapshotDivider/SnapshotDivider';
import { snapshotAppDownloadItems } from '@/ui-components/organisms/Snapshot/snapshotAppDownloadItems';
import styles from './snapshotAppFooter.module.scss';

export interface SnapshotAppFooterProps {
    items?: DownloadButtonProps[];
    showTopDivider?: boolean;
}

export function SnapshotAppFooter({
    items = snapshotAppDownloadItems,
    showTopDivider = true,
}: SnapshotAppFooterProps): React.JSX.Element {
    return (
        <>
            {showTopDivider && <SnapshotDivider />}
            <section className={styles.footer}>
                <Text tag="h6" variant="h6" className={styles.footerHeading}>
                    Get the SiriusXM app
                </Text>
                <AppDownloadButtons
                    items={items}
                    appleClassName={styles.appButtonBadge}
                    androidClassName={styles.appButtonBadge}
                />
            </section>
        </>
    );
}
